export default __webpack_public_path__ + "static/media/titulos_fondo.dfb259cd.png";